<template>
  <div class="basis-locked" @touchmove.prevent @mousewheel.prevent>
    <div class="unlocked-operating-wrapper">
      <p class="label">权限不足，无法观看</p>
      <div class="button-wrapper">
        <template v-if="supportVip">
          <div class="button vip" @click="clickHandler('vip')">
            <slot name="vip-button" :vips="vipsNeeded">
              <p class="title">开通VIP解锁该课程</p>
              <span class="tag">
                最低仅需
                <span v-money="vipsNeeded[0] && vipsNeeded[0].cashNeeded" />
                元
              </span>
            </slot>
          </div>
        </template>
        <template v-if="supportCredits">
          <div class="button credit" @click="clickHandler('credits')">
            <slot name="credits-button" :lockedData="lockedData">
              <p class="title">解锁单字</p>
              <span class="tag">{{ lockedData.creditsNeeded }}积分</span>
            </slot>
          </div>
        </template>
      </div>
    </div>
    <div class="popup-wrapper">
      <vip-list-popup
        v-model="showVipList"
        :vips-needed="vipsNeeded"
      />
    </div>
  </div>
</template>

<script>
import VipListPopup from '@/components/VipListPopup'

export default {
  name: 'BasisLocked',
  components: { VipListPopup },
  props: {
    supportVip: {
      type: Boolean,
      default: false
    },
    supportCredits: {
      type: Boolean,
      default: false
    },

    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    lockedData: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    showVipList: false
  }),
  computed: {
    vipsNeeded () {
      return this.lockedData.vipsNeeded || []
    }
  },
  methods: {
    clickHandler (type) {
      switch (type) {
        case 'vip':
          this.showVipList = true
          break
        case 'credits':
          break
      }
      this.$emit('clickHandler', type)
    }
  }
}
</script>

<style scoped lang="scss">
.basis-locked {
  @include wh(100%, 100%);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  &::before {
    content: " ";
    background-color: #5f5f5f;
    opacity: 0.8;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
  }
  .unlocked-operating-wrapper {
    @include ct;
    z-index: 99;
    .label {
      @include sc($font-size-xlg, #FF7878);
      @include lw(25px, 500);
      padding-bottom: 32px;
      text-align: center;
    }
    .button-wrapper {
      .button {
        @include wh(236px, 60px);
        color: #fff;
        padding: 8px 0;
        text-align: center;
        & + .button {
          margin-top: 8px;
        }
        &.vip {
          @include lg-radius(#E6AC67, #F5C993);
        }
        &.credit {
          border: 1px solid #FFFFFF;
          border-radius: 8px;
        }
        .title {
          @include ft($font-size-xlg, 25px);
        }
        .tag {
          @include ft($font-size-base, 17px);
        }
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
